'use client';

import type { ToastProviderProps } from '@frameio/vapor';
import { ToastProvider, useHasMounted } from '@frameio/vapor';

export function DeferredToastProvider(props: ToastProviderProps) {
  const hasMounted = useHasMounted();
  return hasMounted ? <ToastProvider {...props} /> : null;
}
